import { useEffect, useState } from "react";
import styled from "styled-components";
import { Moon, Sun } from "@phosphor-icons/react";
import { useThemeMode } from "../../providers/AppThemeProvider";

export default function ThemeToggle() {
  const { mode, toggle } = useThemeMode();
  const [mounted, setMounted] = useState(false);

  // Optional: avoids initial flicker if system/theme reads happen after mount
  useEffect(() => setMounted(true), []);

  if (!mounted) return <Btn aria-hidden="true" />;

  const isDark = mode === "dark";
  return (
    <Btn
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Light" : "Dark"}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </Btn>
  );
}

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding-inline: 10px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
`;
